/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  BboForexManagementBadRequestResponse,
  BboForexManagementFailureResponseResponse,
  BboForexManagementForbiddenResponse,
  BboForexManagementUnauthorizedResponse,
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  BboStockManagementBadRequestResponse,
  BboStockManagementFailureResponseResponse,
  BboStockManagementForbiddenResponse,
  BboStockManagementUnauthorizedResponse,
  FailureResponseResponse,
  ForbiddenResponse,
  MockTransferBadRequestResponse,
  MockTransferFailureResponseResponse,
  MockTransferForbiddenResponse,
  MockTransferUnauthorizedResponse,
  TaskApiFailureResponseResponse,
  TaskApiForbiddenResponse,
  TaskApiUnauthorizedResponse,
  UnauthorizedResponse,
  VersionResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Health check that returns service version
 */
export const healthCheck = (signal?: AbortSignal) => {
  return customInstance<VersionResponse>({
    url: `/bm-accounting-location/status`,
    method: 'get',
    signal,
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/bm-accounting-location/status`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) =>
    healthCheck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>;
export type HealthCheckQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
>;

/**
 * @summary Health check that returns service version
 */
export const useHealthCheck = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Health check that returns service version
 */
export const bboCashManagementhealthCheck = (signal?: AbortSignal) => {
  return customInstance<VersionResponse>({
    url: `/BboCashManagementService/status`,
    method: 'get',
    signal,
  });
};

export const getBboCashManagementhealthCheckQueryKey = () => {
  return [`/BboCashManagementService/status`] as const;
};

export const getBboCashManagementhealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof bboCashManagementhealthCheck>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboCashManagementhealthCheck>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBboCashManagementhealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bboCashManagementhealthCheck>>> = ({
    signal,
  }) => bboCashManagementhealthCheck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bboCashManagementhealthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BboCashManagementhealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof bboCashManagementhealthCheck>>
>;
export type BboCashManagementhealthCheckQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | FailureResponseResponse
>;

/**
 * @summary Health check that returns service version
 */
export const useBboCashManagementhealthCheck = <
  TData = Awaited<ReturnType<typeof bboCashManagementhealthCheck>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboCashManagementhealthCheck>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBboCashManagementhealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Health check that returns service version
 */
export const bboDeclarationhealthCheck = (signal?: AbortSignal) => {
  return customInstance<VersionResponse>({
    url: `/bm-declaration-service/status`,
    method: 'get',
    signal,
  });
};

export const getBboDeclarationhealthCheckQueryKey = () => {
  return [`/bm-declaration-service/status`] as const;
};

export const getBboDeclarationhealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof bboDeclarationhealthCheck>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboDeclarationhealthCheck>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBboDeclarationhealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bboDeclarationhealthCheck>>> = ({
    signal,
  }) => bboDeclarationhealthCheck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bboDeclarationhealthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BboDeclarationhealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof bboDeclarationhealthCheck>>
>;
export type BboDeclarationhealthCheckQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Health check that returns service version
 */
export const useBboDeclarationhealthCheck = <
  TData = Awaited<ReturnType<typeof bboDeclarationhealthCheck>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboDeclarationhealthCheck>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBboDeclarationhealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Health check that returns service version
 */
export const bboPouchManagementhealthCheck = (signal?: AbortSignal) => {
  return customInstance<VersionResponse>({
    url: `/bm-pouch-management/status`,
    method: 'get',
    signal,
  });
};

export const getBboPouchManagementhealthCheckQueryKey = () => {
  return [`/bm-pouch-management/status`] as const;
};

export const getBboPouchManagementhealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof bboPouchManagementhealthCheck>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboPouchManagementhealthCheck>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBboPouchManagementhealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bboPouchManagementhealthCheck>>> = ({
    signal,
  }) => bboPouchManagementhealthCheck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bboPouchManagementhealthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BboPouchManagementhealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof bboPouchManagementhealthCheck>>
>;
export type BboPouchManagementhealthCheckQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Health check that returns service version
 */
export const useBboPouchManagementhealthCheck = <
  TData = Awaited<ReturnType<typeof bboPouchManagementhealthCheck>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboPouchManagementhealthCheck>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBboPouchManagementhealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Health check that returns service version
 */
export const bboBranchConfighealthCheck = (signal?: AbortSignal) => {
  return customInstance<VersionResponse>({
    url: `/BboBranchConfigService/status`,
    method: 'get',
    signal,
  });
};

export const getBboBranchConfighealthCheckQueryKey = () => {
  return [`/BboBranchConfigService/status`] as const;
};

export const getBboBranchConfighealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof bboBranchConfighealthCheck>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboBranchConfighealthCheck>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBboBranchConfighealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bboBranchConfighealthCheck>>> = ({
    signal,
  }) => bboBranchConfighealthCheck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bboBranchConfighealthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BboBranchConfighealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof bboBranchConfighealthCheck>>
>;
export type BboBranchConfighealthCheckQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Health check that returns service version
 */
export const useBboBranchConfighealthCheck = <
  TData = Awaited<ReturnType<typeof bboBranchConfighealthCheck>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboBranchConfighealthCheck>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBboBranchConfighealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Health check that returns service version
 */
export const bboStockManagementhealthCheck = (signal?: AbortSignal) => {
  return customInstance<VersionResponse>({
    url: `/bm-stock-management-service/status`,
    method: 'get',
    signal,
  });
};

export const getBboStockManagementhealthCheckQueryKey = () => {
  return [`/bm-stock-management-service/status`] as const;
};

export const getBboStockManagementhealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof bboStockManagementhealthCheck>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboStockManagementhealthCheck>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBboStockManagementhealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bboStockManagementhealthCheck>>> = ({
    signal,
  }) => bboStockManagementhealthCheck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bboStockManagementhealthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BboStockManagementhealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof bboStockManagementhealthCheck>>
>;
export type BboStockManagementhealthCheckQueryError = ErrorType<
  | BboStockManagementBadRequestResponse
  | BboStockManagementUnauthorizedResponse
  | BboStockManagementForbiddenResponse
  | BboStockManagementFailureResponseResponse
>;

/**
 * @summary Health check that returns service version
 */
export const useBboStockManagementhealthCheck = <
  TData = Awaited<ReturnType<typeof bboStockManagementhealthCheck>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboStockManagementhealthCheck>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBboStockManagementhealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Health check that returns service version
 */
export const bboForexManagementhealthCheck = (signal?: AbortSignal) => {
  return customInstance<VersionResponse>({
    url: `/BboForexManagementService/status`,
    method: 'get',
    signal,
  });
};

export const getBboForexManagementhealthCheckQueryKey = () => {
  return [`/BboForexManagementService/status`] as const;
};

export const getBboForexManagementhealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof bboForexManagementhealthCheck>>,
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | BboForexManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboForexManagementhealthCheck>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBboForexManagementhealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bboForexManagementhealthCheck>>> = ({
    signal,
  }) => bboForexManagementhealthCheck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bboForexManagementhealthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BboForexManagementhealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof bboForexManagementhealthCheck>>
>;
export type BboForexManagementhealthCheckQueryError = ErrorType<
  | BboForexManagementBadRequestResponse
  | BboForexManagementUnauthorizedResponse
  | BboForexManagementForbiddenResponse
  | BboForexManagementFailureResponseResponse
>;

/**
 * @summary Health check that returns service version
 */
export const useBboForexManagementhealthCheck = <
  TData = Awaited<ReturnType<typeof bboForexManagementhealthCheck>>,
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | BboForexManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bboForexManagementhealthCheck>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBboForexManagementhealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Health check that returns service version
 */
export const taskApihealthCheck = (signal?: AbortSignal) => {
  return customInstance<VersionResponse>({ url: `/BboTaskApi/status`, method: 'get', signal });
};

export const getTaskApihealthCheckQueryKey = () => {
  return [`/BboTaskApi/status`] as const;
};

export const getTaskApihealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof taskApihealthCheck>>,
  TError = ErrorType<
    | BadRequestResponse
    | TaskApiUnauthorizedResponse
    | TaskApiForbiddenResponse
    | TaskApiFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof taskApihealthCheck>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTaskApihealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof taskApihealthCheck>>> = ({ signal }) =>
    taskApihealthCheck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof taskApihealthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TaskApihealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof taskApihealthCheck>>
>;
export type TaskApihealthCheckQueryError = ErrorType<
  | BadRequestResponse
  | TaskApiUnauthorizedResponse
  | TaskApiForbiddenResponse
  | TaskApiFailureResponseResponse
>;

/**
 * @summary Health check that returns service version
 */
export const useTaskApihealthCheck = <
  TData = Awaited<ReturnType<typeof taskApihealthCheck>>,
  TError = ErrorType<
    | BadRequestResponse
    | TaskApiUnauthorizedResponse
    | TaskApiForbiddenResponse
    | TaskApiFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof taskApihealthCheck>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTaskApihealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Health check that returns service version
 */
export const mockTransferhealthCheck = (signal?: AbortSignal) => {
  return customInstance<VersionResponse>({
    url: `/BboMockTransactionApiService/status`,
    method: 'get',
    signal,
  });
};

export const getMockTransferhealthCheckQueryKey = () => {
  return [`/BboMockTransactionApiService/status`] as const;
};

export const getMockTransferhealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof mockTransferhealthCheck>>,
  TError = ErrorType<
    | MockTransferBadRequestResponse
    | MockTransferUnauthorizedResponse
    | MockTransferForbiddenResponse
    | MockTransferFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof mockTransferhealthCheck>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMockTransferhealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mockTransferhealthCheck>>> = ({
    signal,
  }) => mockTransferhealthCheck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mockTransferhealthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MockTransferhealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof mockTransferhealthCheck>>
>;
export type MockTransferhealthCheckQueryError = ErrorType<
  | MockTransferBadRequestResponse
  | MockTransferUnauthorizedResponse
  | MockTransferForbiddenResponse
  | MockTransferFailureResponseResponse
>;

/**
 * @summary Health check that returns service version
 */
export const useMockTransferhealthCheck = <
  TData = Awaited<ReturnType<typeof mockTransferhealthCheck>>,
  TError = ErrorType<
    | MockTransferBadRequestResponse
    | MockTransferUnauthorizedResponse
    | MockTransferForbiddenResponse
    | MockTransferFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof mockTransferhealthCheck>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getMockTransferhealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
